import React, {useState} from 'react';
import randomstring from "randomstring";

// styles
import styles from './daxkoSignup.module.css';

// components
import Loading from "../Loading/Loading";

const DaxkoSignup = props => {
    // props
    const {scope, state, isExistingUser} = props;
    // local
    const [sent, setSent] = useState(false);

    function sendToDaxko() {
        if (!sent) {
            setSent(true);
            
            let redirectUri;
            if (isExistingUser) {
                // For existing users, redirect to dashboard with code and state
                redirectUri = 'https://habit.treowellness.com/member/clientDash';
            } else {
                // For new users, use the original login redirect
                redirectUri = 'https://habit.treowellness.com/successful_login';
            }
            
            window.location.href = `https://operations.oauth2.partners.daxko.com/authorize?response_type=code&scope=clientIntegrationId%3A${scope}&state=${state}&client_id=prod_treowellness&redirect_uri=${encodeURIComponent(redirectUri)}`;
            return <div/>
        } else {
            return (
                <div className={styles.loadingContainer}>
                    <p>Redirecting to Login. Please Wait.</p>
                    <Loading/>
                </div>
            )
        }
    }

    return sendToDaxko();
}

export default DaxkoSignup;